import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { delay, finalize, Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';
 
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // if (request.method === 'POST' ) {
    //   return next.handle(request);
    // }
    //|| request.url.includes('GetParticipantListForMobile')
    // if (
    //   request.url.includes('GetRegistrationRequestStatus') ||
    //   request.url.includes('SearchParticipantName') 
    // ) {
    //   return next.handle(request);
    // }
    if (request.method === 'DELETE') {
      return next.handle(request);
    }
    this.loadingService.busy();
    return next.handle(request).pipe(
      // delay(1000),
      finalize(() => {
        this.loadingService.idle();
      })
    );
  }
}
